import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import holidayService from '../../services/holidayService';


export const fetchAllHolidays = createAsyncThunk(
  'holiday/fetchAll',
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token;
      const response = await holidayService.getAllHolidays(token);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addHoliday = createAsyncThunk(
  'holiday/add',
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token;
      const response = await holidayService.addHoliday(data, token);
      
 
      if (response.StatusCode === 200 || response.StatusCode === 201) {
        return response;
      } else {
        return rejectWithValue(response.Result || 'Failed to add holiday');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateHoliday = createAsyncThunk(
  'holiday/update',
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token;
      const response = await holidayService.updateHoliday(data, token);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteHoliday = createAsyncThunk(
  'holiday/delete',
  async (holidayId, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token;
      const response = await holidayService.deleteHoliday(holidayId, token);
      return { holidayId, ...response };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  holidays: [],
  loading: false,
  error: null,
  addLoading: false,
  updateLoading: false,
  deleteLoading: false,
};

const holidaySlice = createSlice({
  name: 'holiday',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearHolidays: (state) => {
      state.holidays = [];
    }
  },
  extraReducers: (builder) => {
    builder
      
      .addCase(fetchAllHolidays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllHolidays.fulfilled, (state, action) => {
  state.loading = false; 
  const result = action.payload?.ResultSet || [];
  state.holidays = Array.isArray(result) 
    ? result.filter(holiday => holiday !== null && holiday !== undefined)
    : [];
})
      .addCase(fetchAllHolidays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      // ── Add Holiday ────────────────────────────────────────────────────────
      .addCase(addHoliday.pending, (state) => {
        state.addLoading = true;
        state.error = null;
      })
      .addCase(addHoliday.fulfilled, (state, action) => {
  state.addLoading = false;
  const newHoliday = action.payload?.ResultSet;
  if (newHoliday && newHoliday !== null) {
    state.holidays = [...state.holidays, newHoliday];
  } else {
     
    state.holidays = state.holidays; 
  }
})
      .addCase(addHoliday.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload || action.error.message;
      })
      
      
      .addCase(updateHoliday.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateHoliday.fulfilled, (state, action) => {
        state.updateLoading = false;
        
        const updated = action.payload?.ResultSet;
        if (updated) {
          const index = state.holidays.findIndex(h => h.HAH_HOLIDAY_ID === updated.HAH_HOLIDAY_ID);
          if (index !== -1) {
            state.holidays[index] = updated;
          }
        }
      })
      .addCase(updateHoliday.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload || action.error.message;
      })
      
     
      .addCase(deleteHoliday.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteHoliday.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.holidays = state.holidays.filter(
          h => h.HAH_HOLIDAY_ID !== action.payload.holidayId
        );
      })
      .addCase(deleteHoliday.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearError, clearHolidays } = holidaySlice.actions;
export default holidaySlice.reducer;